/**
 * Demo seed — synchronously primes the Redux store so the REAL agency portal
 * renders fully in demo mode:
 *   - a fake seller + agency session so every route guard passes,
 *   - `employeeIdentity` (owner + all capabilities) so RBAC gates open,
 *   - `sessionResolving=false` + `isInitSuccess=true` so the splash never hangs,
 *   - profile `all_shops`/`active_shop_slug` so the brand selector + Clients work.
 *
 * Must run BEFORE React mounts (called from index.tsx).
 */
import store from '../../store/store';
import {
  setAccessToken,
  setAgencyAccessToken,
  setAgencySessionResolving,
  setEmployeeIdentity,
} from '../../store/reducers/authSlice';
import { setUserCompanyDetails, updateProfile } from '../../store/reducers/userSlice';
import { setIsInitSuccess } from '../../store/reducers/appSlice';
import {
  DEMO_ACTIVE_SHOP,
  DEMO_ALL_SHOPS,
  DEMO_BRANDS,
  DEMO_IDENTITY,
} from './demo-data';

let seeded = false;

export const seedDemoStore = (): void => {
  if (seeded) return;
  seeded = true;
  const { dispatch } = store;

  // Fake session. `expiresOn: null` keeps the token-expiry effect from logging
  // the demo out.
  dispatch(setAccessToken({ sellerToken: 'demo', type: 'Bearer', expiresOn: null }));
  dispatch(setAgencyAccessToken('demo'));
  dispatch(setEmployeeIdentity(DEMO_IDENTITY as never));
  dispatch(setAgencySessionResolving(false));
  dispatch(setIsInitSuccess(true));

  // Profile + brands.
  dispatch(
    updateProfile({
      seller_id: 1,
      user_id: 1,
      role: 'agency',
      all_shops: DEMO_ALL_SHOPS,
      active_shop_slug: DEMO_ACTIVE_SHOP,
      first_name: 'Alex',
      last_name: 'Mercer',
      email: 'alex@aurora-agency.io',
    })
  );

  const active =
    DEMO_BRANDS.find((b) => b.slug === DEMO_ACTIVE_SHOP) ?? DEMO_BRANDS[0];
  dispatch(
    setUserCompanyDetails({
      name: active.name,
      shop_slug: active.slug,
      shop_id: String(active.id),
      webshop_url: active.webshop_url,
      currency: 'EUR',
      currency_symbol: '€',
      is_active: true,
    } as never)
  );
};
